import { Icon, IconsEnum } from 'components/Icons';
import { handleInfoTipoScommessaModal } from 'features/ippica/ippicaSlice';
import { setIndexFilterTipiScommessa } from 'features/sport/sportSlice';
import { Dispatch, SetStateAction } from 'react';
import { useAppDispatch } from 'sites/snai/lib/store';
import styles from './ScommesseFiltersListWithInfo.module.scss';

// TODO mettere array di string & asterischi
export type ScommesseFiltersListWithInfoProps = {
  items: ItemWithInfo[];
  className?: string;
  selectedIndex?: number;
  hasMarginBottom?: boolean;
  hasWhiteBackground?: boolean;
  onSelectedFilter?: Dispatch<SetStateAction<number>>;
};

export type ItemWithInfo = {
  label: string;
  title?: string;
  description: string;
  key: string;
};

export const ScommesseFiltersListWithInfo = ({
  items,
  className,
  selectedIndex,
  hasMarginBottom,
  onSelectedFilter,
  hasWhiteBackground,
}: ScommesseFiltersListWithInfoProps) => {
  const dispatch = useAppDispatch();
  const handleToggle = (index: number) => {
    onSelectedFilter ? onSelectedFilter(index) : dispatch(setIndexFilterTipiScommessa(index));
  };
  return (
    <div className={`${styles.container} ${className ? className : ''} ${hasMarginBottom ? styles.marginBottom : ''} `}>
      {items &&
        items.map((item: ItemWithInfo, index) => {
          return (
            <ScommesseButtonWithInfo
              key={item.key + '_' + index}
              label={item.label}
              title={item.title}
              description={item.description}
              index={index}
              selectedIndex={selectedIndex}
              handleToggle={handleToggle}
              hasWhiteBackground={hasWhiteBackground}
            />
          );
        })}
    </div>
  );
};

export type ScommesseButtonWithInfoProps = {
  label: string;
  title?: string;
  description?: string;
  index: number;
  selectedIndex?: number;
  hasWhiteBackground?: boolean;
  handleToggle: (index: number) => void;
};

export const ScommesseButtonWithInfo: React.FC<ScommesseButtonWithInfoProps> = ({
  label,
  title,
  description,
  index,
  selectedIndex,
  handleToggle,
  hasWhiteBackground,
}) => {
  const dispatch = useAppDispatch();

  return (
    <div className={description ? styles.buttonWrapperWithInfo : styles.buttonWrapper} key={label + '_' + index}>
      <button
        type="button"
        className={`${styles.button} ${selectedIndex === index ? styles.active : ''} ${
          description ? styles.radiusLeftBorder : ''
        } ${hasWhiteBackground && styles.whiteBackground}`}
        onClick={() => {
          handleToggle(index);
        }}
      >
        {label}
      </button>
      {description && (
        <button
          type="button"
          className={`${styles.buttonInfo} ${selectedIndex === index ? styles.active : ''} ${
            hasWhiteBackground && styles.whiteBackground
          }`}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(handleInfoTipoScommessaModal({ isOpen: true, title: title, description }));
          }}
        >
          <Icon iconId={IconsEnum.INFO} className={styles.icon} color="var(--color-on-bg-secondary)" />
        </button>
      )}
    </div>
  );
};
